<template>
  <div class="d-flex flex-column page-container" :style="{ height: screenHeight, width: screenWidth }">
    <div class="a-body flex-grow-1 overflow-y-hidden" v-resize="elSizeChange">
      <PaginationTable 
        :pagination="pagin"
        :columns="tableColumn"
        :dataSource="dataTables"
        :tableSize="tableSize">
        <template slot="domain" slot-scope="{ record }">
          <a-tooltip :title="record.domain" placement="topLeft">
            <p class="mb-0 text-truncate d-block">
              {{ record.domain }}
            </p>
          </a-tooltip>
        </template>
        <template slot="status" slot-scope="{ record }">
          <div>
            <a-tag :color="DomainStatusColor[record.status] || DomainStatusColor.NotOK" class="status-tag">
              <router-link :to="'./' + record.id + '/' + record.domain + '/dns-history'">
                {{ record.status }}
              </router-link>
            </a-tag>
          </div>
        </template>
        <template slot="lastVerified" slot-scope="{ record }">
          <div>
            <div>
              <time>
                {{ record.lastVerified | dateString }}
              </time>
            </div>
            <div>
              <time>
                {{ record.lastVerified | timeString }}
              </time>
            </div>
            <template v-if="record.lastChangeAt">
              <p class="font-weight-bold mb-0 mt-2">Last change:</p>
              <div>
                <time>
                  {{ record.lastChangeAt | dateString }}
                </time>
              </div>
              <div>
                <time>
                  {{ record.lastChangeAt | timeString }}
                </time>
              </div>
            </template>
          </div>
        </template>
        <template slot="interval" slot-scope="{ record }">
          <span>{{ formatMonitoringInterval(record.interval) }}</span>
        </template>
        <template slot="contactGroup" slot-scope="{ record }">
          <div class="group-select-container">
            <a-select size="large" :default-value="record.contactGroup" @change="(e) => handleChangeGroup(e, record)">
              <a-select-option v-for="contactGroup in contactGroups" :key="contactGroup.value" :value="contactGroup.value">
                {{ contactGroup.label }}
              </a-select-option>
            </a-select>
          </div>
        </template>
        <template slot="operation" slot-scope="{ record }">
          <a-dropdown placement="topLeft">
            <a-icon class="operation" type="ellipsis" />
            <a-menu slot="overlay">
              <a-menu-item>
                <div @click.prevent="() => handleOpenModalRecord(record)">
                  <a-icon type="eye" /> View Record
                </div>
              </a-menu-item>
              <a-menu-item>
                <div @click.prevent="() => handleRebaselineRecord(record)">
                  <a-icon type="sync" /> Rebaseline Record
                </div>
              </a-menu-item>
              <a-menu-item>
                <router-link class="nav-link-detail" :to="'./' + record.id + '/' + record.domain + '/dns-history'">
                  <a-icon type="history" /> History
                </router-link>
              </a-menu-item>
              <a-menu-item>
                <div class="full-wh" @click="showDeleteConfirm(record)">
                  <a-icon type="delete" /> Delete
                </div>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </template>
      </PaginationTable>
    </div>
    <div class="a-footer" :style="{ width: paginationBarWidth }">
      <PaginationBar :pageSize.sync="pagin.pageSize" :total="pagin.total" @change="paginChange" />
    </div>
    <a-modal 
      v-model="isOpenViewRecordModal"
      width="fit-content"
      cancelText="Close"
      :title="titleRecordModal"
      :okButtonProps="{ style: { display: 'none' } }"
      :dialogStyle="{ top: '20px', maxWidth: '80vw' }"
      :bodyStyle="{ padding: '10px', overflowY: 'auto', height: 'auto', maxHeight: 'calc(80vh - 20px)' }">
      <div>
        <pre class="mb-0 modal-content-text">{{ recordsInModal }}</pre>
      </div>
    </a-modal>
  </div>
</template>

<script>
  import { DomainMonitorListColumn } from '../columnsTable/DomainMonitorColumn';
  import { DomainStatusColor } from '../consts/domainStatus.const';
  import DomainMonitorService from '../services/DomainMonitor.service';
  import { formatMonitoringInterval } from '../consts/monitoringInterval.const';

  export default {
    name: 'DNSMonitoringList',
    props: {
      screenSize: {
        type: Object,
        default: () => ({
          height: '100%',
          width: '100%'
        })
      }
    },
    watch: {
      screenSize: {
        immediate: true,
        handler({ height, width }) {
          const screenHeight = height ? (height - 44 - 16 - 60) : 0;
          this.screenHeight = screenHeight ? screenHeight + 'px' : '100%';
          this.screenWidth = width ? width + 'px' : '100%';
        }
      },
    },
    data() {
      return {
        DomainStatusColor,
        tableColumn: [],
        dataTables: [],
        contactGroups: [],
        isOpenViewRecordModal: false,
        recordsInModal: '',
        titleRecordModal: '',
        tableSize: {
          height: '',
          width: ''
        },
        screenHeight: '100%',
        screenWidth: '100%',
        paginationBarWidth: '100%',
        pagin: {
          current: 1,
          pageSize: 5,
          total: 0
        },
      };
    },
    beforeMount() {
      this.tableColumn = DomainMonitorListColumn('DNS');
    },
    mounted() {
      this.fetchList();
      this.fetchContactGroup();
    },
    methods: {
      formatMonitoringInterval,
      async fetchList() {
        const response = await DomainMonitorService.fetchDnsList();
        this.dataTables = (response || []).map((item, index) => ({
          id: item.id,
          index: index + 1,
          domain: item.domain,
          status: item.status,
          interval: item.interval,
          lastVerified: item.last_verified_at,
          lastChangeAt: item.last_changed_at,
          contactGroup: item.contact_group_id,
        }));
        this.pagin.total = this.dataTables.length;
      },
      async fetchContactGroup() {
        const contactGroups = await DomainMonitorService.fetchContactGroups();
        this.contactGroups = (contactGroups || []).map((contactGroup) => {
          if (contactGroup.description === 'DEFAULT') {
            this.initDefaultContactGroup = contactGroup.id;
          }
          return {
            label: contactGroup.description,
            value: contactGroup.id
          };
        });
      },
      async handleChangeGroup(event, record) {
        const bodyUpdate = {
          contact_group_id: event
        };
        await DomainMonitorService.updateOneDns(record.id, bodyUpdate);
      },
      async handleOpenModalRecord(record) {
        const recordData = await DomainMonitorService.fetchDnsMonitoringRecordById(record.id);
        this.recordsInModal = recordData.data;
        this.titleRecordModal = record.domain;
        this.isOpenViewRecordModal = true;
      },
      // ---> DNSMonitoringList dropdown menu > handleRebaselineRecord > DomainMonitorService.rebaselineDns
      handleRebaselineRecord(record) {
        this.$confirm({
          title: 'Rebaseline DNS Record',
          content: `Are you sure you want to rebaseline the DNS record for "${record.domain}"? This will set the current DNS records as the new baseline.`,
          okText: 'Yes, Rebaseline',
          okType: 'primary',
          cancelText: 'Cancel',
          onOk: async () => {
            try {
              await DomainMonitorService.rebaselineDns(record.id);
              this.$notification.success({
                message: 'Success',
                description: `DNS record for "${record.domain}" has been rebaselined successfully.`,
                duration: 5,
              });
              this.fetchList();
            } catch (error) {
              const messageErr = (error && error.messages && error.messages[0]) || 'Failed to rebaseline DNS record';
              this.$notification.error({
                class: 'custom-notification error-message',
                message: 'Error',
                description: messageErr,
                duration: 10,
              });
            }
          }
        });
      },
      showDeleteConfirm(record) {
        this.$confirm({
          title: 'Are you sure want to delete?',
          okText: 'Yes',
          okType: 'danger',
          cancelText: 'No',
          onOk: async () => {
            await DomainMonitorService.deleteDnsById(record.id);
            this.fetchList();
          }
        });
      },
      paginChange(pagin) {
        this.pagin = { ...pagin };
      },
      elSizeChange(size) {
        this.tableSize = size;
        this.paginationBarWidth = size.width + 'px';
      }
    }
  };
</script>
<style lang="scss" scoped>
  .page-container, .a-footer {
    transition: all 300ms linear;
  }
  .modal-content-text {
    white-space: break-spaces;
  }
  .status-tag {
    width: fit-content;
    min-width: 50px;
    text-align: center;
  }
  .group-select-container {
    padding-right: 10px;
  }
</style>
